import { useEffect } from "react";
import { siteConfig } from "../../config/site";

const ensureMeta = (name, attr = "name") => {
  const selector = `meta[${attr}='${name}']`;
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  return tag;
};

const ensureLink = (rel) => {
  let link = document.head.querySelector(`link[rel='${rel}']`);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }
  return link;
};

const upsertJsonLd = (id, data) => {
  let script = document.head.querySelector(`script[data-seo-id='${id}']`);
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-seo-id", id);
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
};

export default function Seo({
  title,
  description,
  canonical,
  image = siteConfig.logoUrl,
  type = "website",
  schema = [],
}) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      ensureMeta("description").setAttribute("content", description);
      ensureMeta("og:description", "property").setAttribute("content", description);
      ensureMeta("twitter:description").setAttribute("content", description);
    }

    if (title) {
      ensureMeta("og:title", "property").setAttribute("content", title);
      ensureMeta("twitter:title").setAttribute("content", title);
    }

    if (canonical) {
      ensureLink("canonical").setAttribute("href", canonical);
      ensureMeta("og:url", "property").setAttribute("content", canonical);
    }

    ensureMeta("og:type", "property").setAttribute("content", type);
    ensureMeta("og:image", "property").setAttribute("content", image);
    ensureMeta("twitter:card").setAttribute("content", "summary_large_image");
    ensureMeta("twitter:image").setAttribute("content", image);

    schema.forEach((item, index) => upsertJsonLd(`schema-${index}`, item));
  }, [title, description, canonical, image, type, schema]);

  return null;
}
